import { createSlice } from '@reduxjs/toolkit';

// What full-page loading UI (if any) the current page wants:
//   'none'     - not in a blocking load; the shared spinner follows pendingCount
//   'spinner'  - show the shared GlobalSpinner even if no axios request is in
//                flight right now (e.g. react-query retry backoff / processing)
//   'skeleton' - the page shows its own skeleton, so suppress the shared spinner
// The two overrides ('spinner' forces on, 'skeleton' forces off) are mutually
// exclusive, so a single tri-state field expresses both.
export type PageLoadingMode = 'none' | 'spinner' | 'skeleton';

export interface LoadingStateProps {
  pendingCount: number;
  pageLoadingMode: PageLoadingMode;
}

const initialState: LoadingStateProps = {
  pendingCount: 0,
  pageLoadingMode: 'none',
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    startRequest(state) {
      state.pendingCount += 1;
    },
    endRequest(state) {
      state.pendingCount = Math.max(0, state.pendingCount - 1);
    },
    resetRequests(state) {
      state.pendingCount = 0;
    },
    setPageLoadingMode(state, action: { payload: PageLoadingMode }) {
      state.pageLoadingMode = action.payload;
    },
  },
});

export const { startRequest, endRequest, resetRequests, setPageLoadingMode } =
  loadingSlice.actions;
export default loadingSlice.reducer;
